import { useTranslation } from 'react-i18next'
import { useState } from "react"
import { Box, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, ToggleButton, ToggleButtonGroup, useColorScheme } from "@mui/material";
import dayjs from "dayjs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLaptop, faMoon, faSun } from "@fortawesome/free-solid-svg-icons";


const DarkModeSwap = () => {
  const { i18n, t } = useTranslation();
  const { mode, setMode } = useColorScheme();

  const toggleTheme = (event) => {
    setMode(event.target.value as 'system' | 'light' | 'dark')
  };

  if (!mode) {
    return null;
  }
  return (
      <FormControl>
        <RadioGroup
          aria-labelledby="demo-theme-toggle"
          name="theme-toggle"
          row
          value={mode}
          onChange={(event) =>
            setMode(event.target.value as 'system' | 'light' | 'dark')
          }
        >
          <FormControlLabel value="system" control={<Radio size="small"/>} label={<FontAwesomeIcon icon={faLaptop}/>} />
          <FormControlLabel value="light" control={<Radio size="small"/>} label={<FontAwesomeIcon icon={faSun}/>} />
          <FormControlLabel value="dark" control={<Radio size="small"/>} label={<FontAwesomeIcon icon={faMoon}/>} />
        </RadioGroup>
      </FormControl>
  );
}
export default DarkModeSwap
